import { render } from "./EventosView.vue?vue&type=template&id=25426cda&scoped=true"
import script from "./EventosView.vue?vue&type=script&lang=js"
export * from "./EventosView.vue?vue&type=script&lang=js"

import "./EventosView.vue?vue&type=style&index=0&id=25426cda&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25426cda"]])

export default __exports__